export enum Locale {
  Ca = "ca",
  CaEs = "ca-ES",
  DeCh = "de-CH",
  De = "de",
  DeDe = "de-DE",
  En = "en",
  EnAu = "en-AU",
  EnCa = "en-CA",
  EnDe = "en-DE",
  EnEurope = "en-EUROPE",
  EnGb = "en-GB",
  EnGlobal = "en-GLOBAL",
  EnNz = "en-NZ",
  EnUs = "en-US",
  EnZa = "en-ZA",
  Es = "es",
  EsEs = "es-ES",
  Fr = "fr",
  FrCh = "fr-CH",
  FrFr = "fr-FR",
  FrCa = "fr-CA",
  Id = "id",
  IdId = "id-ID",
  Pt = "pt",
  PtBr = "pt-BR",
}

export const DEFAULT_LOCALE: Locale = Locale.En

export const LOCALE_SEPARATOR = "-"

export const LOCALES = Object.values(Locale)
